import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, PetTransaction } from "@/types";

export const petTransactionsQueryKey = (userId: number) =>
  ["pet-transactions", userId] as const;

// Ledger for one user, newest first.
export function useGetPetTransactions(userId: number | undefined) {
  return useQuery({
    queryKey: petTransactionsQueryKey(userId ?? -1),
    queryFn: async () => {
      const path = `pets/${String(userId)}/transactions`;
      const res = await guacHttpClient.get<
        PetTransaction[],
        HttpResponse<PetTransaction[]>
      >(path);
      return res.data;
    },
    enabled: userId !== undefined,
  });
}
